/* MCR · "Notify me when available": shown only while the selected variant is sold out. */
(function () {
  if (customElements.get('mcr-notify')) return;
  customElements.define('mcr-notify', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      function read(sel) { try { return JSON.parse(self.querySelector(sel).textContent); } catch (e) { return []; } }
      this.avail = read('[data-mcr-notify-variants]');
      this.ids = read('[data-mcr-notify-ids]');
      this.titles = read('[data-mcr-notify-titles]');
      var toggle = this.querySelector('[data-mcr-notify-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var fields = self.querySelector('.mcr-notify__fields');
          var open = fields.hidden;
          fields.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) { var i = fields.querySelector('input[type=email]'); if (i) i.focus(); }
        });
      }
      if (this.querySelector('.mcr-notify__done, .mcr-notify__error')) {
        this.hidden = false;
        var f = this.querySelector('.mcr-notify__fields');
        if (f) f.hidden = false;
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
          var v = payload && payload.data && payload.data.variant;
          if (!v) return;
          self.update(v.id, v.available, v.title);
        });
      }
    }
    update(id, available, title) {
      if (available === undefined) {
        var i = this.ids.indexOf(id);
        available = i > -1 ? this.avail[i] : true;
        title = this.titles[i];
      }
      if (this.querySelector('.mcr-notify__done')) return;
      this.hidden = !!available;
      var field = this.querySelector('[data-mcr-notify-variant]');
      if (field) field.value = (title || '') + ' (' + id + ')';
    }
  });
})();
